var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"zoox-component zoox-country-flag flag-icon",class:_vm.countryFlag,style:(_vm.flagStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }